export const MentionDataset = {
  Mention: 'mention',
  MentionUser: 'mentionUser',
};

export const MentionSelectors = {
  MentionUser: '[data-mention="user"]',
};
